import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatSelect } from "@angular/material/select";

import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { SubSink } from "@dffedb/rxjs";
import { Huskeliste, HuskelisteRepository } from "@e-forsyning/common/huskeliste";

@Component({
    selector: "installationer-huskeliste",
    styleUrls: ["./installationer-huskeliste.component.scss"],
    templateUrl: "./installationer-huskeliste.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstallationerHuskelisteComponent implements OnInit, OnDestroy {
    private readonly subs = new SubSink();
    public options$: Observable<Huskeliste[]>;
    private _fastHuskelisteId: number;

    @Input()
    public control: UntypedFormControl;

    @Input()
    public set fastHuskelisteId(value: number) {
        this._fastHuskelisteId = value;
        if (this.control) {
            this.updateControlState();
        }
    }

    public get fastHuskelisteId(): number {
        return this._fastHuskelisteId;
    }

    @Output()
    public valueChange = new EventEmitter<number>();

    @ViewChild(MatSelect, { static: true })
    public matSelect: MatSelect;

    constructor(private readonly repository: HuskelisteRepository) {}

    public ngOnInit(): void {
        this.options$ = this.repository.hentHuskelister().pipe(map((result) => [{ key: null, value: "" }, ...result]));

        if (this._fastHuskelisteId) {
            this.updateControlState();
        }

        // Det vil være lettere at binde op på eventet i html-templaten
        // Der er imidlertid et issue med at valg af den blanke værdi fyrer selectionChange-eventet to gange.
        // Vi løser det ved at subscribe på selectionChange som en stream og filtere dubletter fra.
        // https://github.com/angular/components/issues/10675
        this.subs.sink = this.matSelect.selectionChange.pipe(distinctUntilChanged((x, y) => x.value === y.value)).subscribe((event) => {
            this.valueChange.emit(event.value);
        });
    }

    private updateControlState(): void {
        if (this._fastHuskelisteId) {
            this.control.setValue(this._fastHuskelisteId);
            this.control.disable();
        } else {
            this.control.enable();
        }
    }

    public ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
